// needed to set the path for Images used in JS files.
// import was required to set the value before the other imports.
// the other imports are used so this file can be used on SiteBuilder with a different assetsDirectory
import "./assetsDirectory.js";

// Common Helpers
import "../../Common/js/commonFiles.js";

// Javscript Apps
import "../../Common/js/jsComponents.js";

// React Components
import "../../Common/js/reactComponents.js";
import initStoryBuilder from "../../Common/js/components/StoryBuilder/initStoryBuilder.js";

// GFO Common Helpers
import scTracking from "../../Common/js/components/SCTracking/sc-tracking.js";

//GFO React Components

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  // JS Apps
  // Story Builder component is not initiated with other components because
  // it needs to be initialized after the Youtube React component mounts
  initStoryBuilder();

  // React Apps

  // SC tracking for social follow (note: not ShareBar)
  document.querySelectorAll(".js-social-follow").forEach((elm) => {
    elm.addEventListener("click", () => scTracking("socialfollow"));
  });

  // SC tracking for downloads
  // This might need to be made more robust in the future.
  // Only set to watch Arrow Link clicks of type "download" for now
  document.querySelectorAll(".arrow-link--download").forEach((elm) => {
    elm.addEventListener("click", () => scTracking("download"));
  });
});
